<div class="auto-refresh-container" ngbDropdown #ddManage="ngbDropdown">
  <span class="refresh-label">Atualizar a cada:</span>
  <button class="btn btn-outline-primary btn-rounded" ngbDropdownToggle type="button" aria-haspopup="true"
    [attr.aria-expanded]="ddManage.isOpen()">
    <div class="d-flex align-items-center justify-content-between">
       <i class="material-icons">autorenew</i>
        <span class="ms-1 me-1">{{ selectedLabel }}</span>
        <i class="material-icons">
          {{ ddManage.isOpen() ? 'expand_less' : 'expand_more' }}
        </i>
    </div>

    <div ngbDropdownMenu class="refresh-options-box">
      <div class="refresh-option"
        (click)="setInterval(intervals.OFF); ddManage.close()">
        Não atualizar
      </div>

      <div class="refresh-option"
        (click)="setInterval(intervals.THIRTY_SECONDS); ddManage.close()">
        30 seg
      </div>

      <div class="refresh-option"
        (click)="setInterval(intervals.ONE_MINUTE); ddManage.close()">
        1 min
      </div>

      <div class="refresh-option"
        (click)="setInterval(intervals.NINETY_SECONDS); ddManage.close()">
        1m 30s
      </div>
    </div>
  </button>
  @if (countdownSeconds() > 0) {
    <span class="refresh-label" >{{ countdownSeconds() }}</span>
  }
</div>